"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClient = void 0;
const react_1 = require("react");
const ApiClientContext_1 = require("../contexts/ApiClientContext");
const guid_1 = require("../apis/spg/util/guid");
/**
 * A generic hook that will return the client that has been setup
 * for the particular app through the ApiClientContext provider.
 *
 * @example
 * const client = useClient<NextClient>()
 * // will return the instantiated nextClient for the app
 * client.patient.get(21);
 * // use like you would normally.
 *
 * @note
 * this hook will re-render when the session changes, however, if your component is sensitive to session changes,
 * you should add `client.auth.session` as a dependency, as it is a nested property on the client,
 * and react hooks only do shallow comparisons.
 */
const useClient = () => {
    const context = (0, react_1.useContext)(ApiClientContext_1.ApiClientContext);
    if (context.client === undefined) {
        throw new Error("The ApiClientContext provider has not been created, please set the value of client.");
    }
    const [, setForceRerender] = (0, react_1.useState)((0, guid_1.createGuid)());
    (0, react_1.useEffect)(() => {
        const handleClientAuthChange = () => setForceRerender((0, guid_1.createGuid)());
        context.client.auth.on("sessionChange", handleClientAuthChange);
        context.client.auth.on("sessionTemporaryAccessChange", handleClientAuthChange);
        return () => {
            context.client.auth.off("sessionChange", handleClientAuthChange);
            context.client.auth.off("sessionTemporaryAccessChange", handleClientAuthChange);
        };
    }, [context.client]);
    return context.client;
};
exports.useClient = useClient;
//# sourceMappingURL=useClient.js.map